<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <Header/>
        <b-container fluid>
            <b-row class="titulo">
                <b-col class="seccionTitulo">
                    <span class="fa fa-table"></span>
                    <span>Usuarios </span>
                </b-col>
                <b-col class="seccionCodigo">
                    <div>BO_04</div>
                </b-col>
            </b-row>

            <b-row>
                <b-col class="subtitulos text-left">
                    Búsqueda de usuarios
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-row align-v="center" align-h="end">
                        <b-col>

                            <b-form-group align="left">
                                <label for="nombreBusq">Buscar</label>
                                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input name="nombre" placeholder="Nombre, nombre de usuario, grupos, perfiles, permisos" min="3"
                                                  v-model="filtro.palabraClave" @keydown.enter.native="obtenerUsuarios"
                                    ></b-form-input>
                                </b-input-group>
                            </b-form-group>

                        </b-col>

                        <b-col></b-col>

                        <b-col align="right">
<!--                            <b-button v-b-tooltip.hover title="Crear usuario" variant="outline-success"-->
<!--                                      @click="agregar()">Crear usuario-->
<!--                            </b-button>-->
                        </b-col>

                    </b-row>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-table
                            id="Pendientes"
                            thead-tr-class="columnas"
                            :items="datosTabla"
                            :fields="fields"
                            :per-page="registrosPorPagina"
                            :current-page="paginaActual"
                            responsive="true"
                            class="parrafos"
                            fixed>
                        <template v-slot:cell(Acciones)="row">
                            <b-button-group>
                                <b-button v-if="$localStorageService.can('BO_04_modif_usuarios')"
                                        title="Modificar Usurio"
                                        size="sm"
                                        @click="modificar(row.item)"
                                        variant="outline-warning"
                                ><em class="fa fa-pencil"></em></b-button>
                                <b-button v-if="!row.item.registroActivo && $localStorageService.can('BO_04_activar_usuario') "
                                          title="Activar usuario"
                                          variant="outline-danger"
                                          size="sm"
                                          @click="eliminar(row.item)"
                                ><em class="fa fa-undo"></em></b-button>
                                <b-button v-else-if="$localStorageService.can('BO_04_baja_usuario')"
                                          title="Eliminar usuario"
                                          variant="outline-danger"
                                          size="sm"
                                          @click="eliminar(row.item)"
                                >
                                    <b-icon icon="trash-fill"></b-icon>
                                </b-button>
                            </b-button-group>

                        </template>
                        <template v-slot:cell(Grupos-Menú)="row">
                            <div v-for="item in row.item.grupos"
                                     :key="item.nombreGrupo+row.item.nombreUsuario+'g'" variant="secondary">{{item.nombreGrupo}}</div>
                        </template>
                        <template v-slot:cell(Clínicas)="row">
                            <div  v-for="item in row.item.clinicas"
                                     :key="item+row.item.nombreUsuario+'c'" variant="secondary">{{item}}</div>
                        </template>
                        <template v-slot:cell(Perfiles-Menú)="row">
                            <div  v-for="item in row.item.perfiles"
                                     :key="item+row.item.nombreUsuario+'p'" variant="secondary">{{item}}</div>
                        </template>
                        <template v-slot:cell(completo)="row">
                            {{row.item.nombre+' '+row.item.paterno+' '+row.item.materno}}
                        </template>
                      <template v-slot:cell(fechaModificacionEmpleado)="row">
                        {{row.item.fechaModificacionEmpleado |formatoFechaCorta}}
                      </template>

                    </b-table>
                    <div align="center" v-if="loader">
                        <b-spinner variant="primary" label="Spinning"></b-spinner>
                    </div>
                    <b-col v-if="!loader">
                        <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
                    </b-col>
                    <b-col v-if="!loader">
                        <b-pagination
                                v-if="datosTabla !== undefined && datosTabla.length > 10"
                                align="center"
                                v-model="paginaActual"
                                :total-rows="datosTabla.length"
                                :per-page="registrosPorPagina"
                                aria-controls="my-table1"
                        ></b-pagination>
                    </b-col>
                </b-col>


            </b-row>

        </b-container>


        <b-modal
                v-model="show"
                :title="tituloModal"
                size="lg"
        >
            <b-container fluid>
                        <b-form>
                            <b-row>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="nombrePerfil">Nombre
                                            <validacion />
                                        </label>
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="person-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input id="nombrePerfil" name="nombreMenu" placeholder="Nombre del perfil"
                                                          v-model="$v.usuario.nombre.$model"
                                                          :state="validateState('nombre')"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="paterno">Apellido Paterno
                                            <validacion />
                                        </label>
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="person-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input id="paterno" name="paterno" placeholder="Apellido Paterno"
                                                          v-model="$v.usuario.paterno.$model"
                                                          :state="validateState('paterno')"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="materno">Apellido Materno
                                            <validacion />
                                        </label>
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="person-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input id="materno" name="materno" placeholder="Apellido Materno"
                                                          v-model="$v.usuario.materno.$model"
                                                          :state="validateState('materno')"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="fechaNacimiento">Fecha de nacimiento
                                            <validacion />
                                        </label>
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="calendar2-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-datepicker id="fechaNacimiento" name="materno"
                                                               placeholder="Fecha de nacimiento"
                                                               v-model="$v.usuario.fechaNacimiento.$model"
                                                               :state="validateState('fechaNacimiento')"
                                            ></b-form-datepicker>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="sexo">Sexo</label>
                                        <validacion />
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="person-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <v-select id="sexo" name="sexo"
                                                      placeholder="Sexo"
                                                      v-model="usuario.sexo"
                                                      label="nombre"
                                                      :options="sexosFiltro"
                                                      style="width: 90%"
                                                      :filterable="false"
                                                      @search="filtroSexo"
                                            ></v-select>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="estadoCivils">Estado civil</label>
                                        <validacion />
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="menu-button-wide-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <v-select id="estadoCivils" name="estadoCivils"
                                                      placeholder="Estado civil"
                                                      v-model="usuario.estadoCivil"
                                                      label="descripcion"
                                                      :options="estadoCivilsFiltro"
                                                      style="width: 90%"
                                                      :filterable="false"
                                                      @search="filtroestadoCivils"
                                            ></v-select>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="ocupacion">Ocupación</label>
                                        <validacion />
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="briefcase-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <v-select id="ocupacion" name="ocupacion"
                                                      placeholder="ocupación"
                                                      v-model="usuario.ocupacion"
                                                      label="descripcion"
                                                      :options="ocupacionesFiltro"
                                                      style="width: 90%"
                                                      :filterable="false"
                                                      @search="filtroOcupaciones"
                                            ></v-select>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="medio">Medio de contacto</label>
                                        <validacion />
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="telephone-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <v-select id="medio" name="medio"
                                                      placeholder="Medio de contacto"
                                                      v-model="usuario.medioContacto"
                                                      label="descripcion"
                                                      :options="mediosContactoFiltro"
                                                      style="width: 95%"
                                                      :filterable="false"
                                                      @search="filtroMediosContacto"
                                            ></v-select>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="nombreUsuario">Nombre de usuario
                                            <validacion />
                                        </label>
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="person-badge-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input id="nombreUsuario" name="nombreUsuario"
                                                          placeholder="Nombre de usuario"
                                                          v-model="$v.usuario.nombreUsuario.$model"
                                                          :state="validateState('nombreUsuario')"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-button variant="outline-primary" v-if="usuario.idUsuario !== null && mostrarBoton"
                                              @click="cambiarContrasenia"> Cambiar contraseña
                                    </b-button>

                                    <b-form-group align="left" v-if="!mostrarBoton">
                                        <label for="password">Contraseña
                                            <validacion />
                                        </label>
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="key-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input id="password" name="password" placeholder="Contraseña"
                                                          type="password"
                                                          v-model="$v.usuario.password.$model"
                                                          :state="validateState('password')"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                    <b-button variant="outline-danger" v-if="usuario.idUsuario !== null && !mostrarBoton"
                                              @click="cancelarCambio"> Cancelar cambio de contraseña
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="mesesVigencia">Tiempo de vigencia (Meses)
                                            <validacion />
                                        </label>
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="hourglass-split"></b-icon>
                                            </b-input-group-prepend>
                                            <b-form-input type="number" id="mesesVigencia" name="mesesVigencia"
                                                          placeholder="Numero de meses de vigencia"
                                                          v-model="$v.usuario.mesesVigencia.$model"
                                                          :state="validateState('mesesVigencia')"
                                            ></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group align="left">
                                        <label for="grupos">Grupos</label>
                                        <validacion />
                                        <b-input-group size="sm" class="mb-2">
                                            <b-input-group-prepend is-text>
                                                <b-icon icon="people-fill"></b-icon>
                                            </b-input-group-prepend>
                                            <v-select id="grupos" name="grupos"
                                                      multiple
                                                      placeholder="Grupos"
                                                      v-model="usuario.grupos"
                                                      label="nombreGrupo"
                                                      :options="grupos"
                                                      style="width: 95%"
                                            ></v-select>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-form>
            </b-container>
            <div slot="modal-footer">
                <b-button variant="outline-primary" :disabled="loaderAcciones" @click.prevent="guardar" v-if="$localStorageService.can('BO_04_alta_usuarios')">
                    <span v-if="!loaderAcciones">Guardar</span>
                    <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                    Cargando...
                    </span>
                </b-button>
                <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Header from "../../components/Header";
    import {validationMixin} from "vuelidate";
    import {required} from "vuelidate/lib/validators";

    export default {
        name: "usuarios",
        components: {
            Header
        },
        mixins: [validationMixin],
        data: () => {
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,

                datosTabla: [],
                sexos: [],
                sexosFiltro: [],
                estadoCivils: [],
                estadoCivilsFiltro: [],
                ocupaciones: [],
                ocupacionesFiltro: [],
                mediosContacto: [],
                mediosContactoFiltro: [],
                grupos: [],
                fields: [
                    {key: "idUsuario", label: "ID", sortable: true},
                    {key: "nombreUsuario", label: "Nombre de usuario", sortable: true},
                    {key: "completo", label: "Nombre completo", sortable: true},
                    "Clínicas",
                    "Grupos-Menú",
                    "Perfiles-Menú",
                    {key: "fechaModificacionEmpleado", label: "Fecha modificación", sortable: true},
                    {key: "nombreUsuarioModificacion", label: "Nombre usuario que modificó", sortable: true},
                    "Acciones",
                ],
                registrosPorPagina: 10,
                paginaActual: 0,
                show: false,
                tituloModal: '',
                usuario: {
                    idUsuario: null,
                    sexo: null,
                    estadoCivil: null,
                    ocupacion: null,
                    medioContacto: null,
                    paterno: null,
                    materno: null,
                    nombre: null,
                    fechaNacimiento: null,
                    nombreUsuario: null,
                    password: null,
                    mesesVigencia: null,
                    grupos: null,
                    registroActivo: null,
                    clinicas: null,
                    cambioPassword: true
                },
                loaderAcciones: false,
                loader: false,
                respContrasenia: null,
                mostrarBoton: false,
                filtro: {
                    id: null,
                    palabraClave: null,
                    registroActivo: null
                },
            }
        },
        validations: {
            usuario: {
                // sexo: {required},
                // estadoCivil: {required},
                // ocupacion: {required},
                // medioContacto: {required},
                paterno: {required},
                materno: {required},
                nombre: {required},
                fechaNacimiento: {required},
                nombreUsuario: {required},
                password: {required},
                mesesVigencia: {required}
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
            this.catalogos();
        },
        methods: {
          filtroMediosContacto(busqueda, loading){
            loading(true)
            let seach = busqueda.trim()
            this.mediosContactoFiltro = this.mediosContacto.filter(em => {
              return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
            )
            loading(false)
          },
          filtroOcupaciones(busqueda, loading){
            loading(true)
            let seach = busqueda.trim()
            this.ocupacionesFiltro = this.ocupaciones.filter(em => {
              return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
            )
            loading(false)
          },
          filtroestadoCivils(busqueda, loading){
            loading(true)
            let seach = busqueda.trim()
            this.estadoCivilsFiltro = this.estadoCivils.filter(em => {
              return em.descripcion.toLowerCase().includes(seach.toLowerCase())}
            )
            loading(false)
          },
          filtroSexo(busqueda, loading){
            loading(true)
            let seach = busqueda.trim()
            this.sexosFiltro = this.sexos.filter(em => {
              return em.nombre.toLowerCase().includes(seach.toLowerCase())}
            )
            loading(false)
          },
            obtenerUsuarios() {
                this.loader = true;
                this.datosTabla = [];
                this.$http.post(this.$api + 'catalogo/usuario/listaUsuario', this.filtro).then(respuesta => {
                        if (respuesta.data.data) {
                            this.datosTabla = respuesta.data.data;
                            this.datosTabla.forEach(element => {
                                element.fechaModificacion = this.$moment(element.fechaModificacion).format('DD-MM-YYYY');
                            });
                        }

                    }
                ).finally(() => {
                        this.loader = false;
                    }
                )
            },
            catalogos() {
                this.$http.post(this.$api + "catalogos/listaSexo").then(response => {
                        if (response.data.data) {
                            this.sexos = response.data.data
                            this.sexosFiltro = this.sexos;
                        }

                    }
                )
                this.$http.get(this.$api + "catalogos/listaEstadoCivil").then(response => {
                        if (response.data.data) {
                            this.estadoCivils = response.data.data
                          this.estadoCivilsFiltro = this.estadoCivils;
                        }

                    }
                )
                this.$http.get(this.$api + "catalogos/listaOcupacion").then(response => {
                        if (response.data.data) {
                            this.ocupaciones = response.data.data
                            this.ocupacionesFiltro = this.ocupaciones;
                        }

                    }
                )
                this.$http.get(this.$api + "catalogos/listaMediosContacto").then(response => {
                        if (response.data.data) {
                            this.mediosContacto = response.data.data
                            this.mediosContactoFiltro = this.mediosContacto;
                        }

                    }
                )
                this.$http.post(this.$api + 'catalogos/grupos/obtenerGrupos', {
                    id: null,
                    palabraClave: null,
                    registroActivo: true
                }).then(respuesta => {
                        if (respuesta.data.data) {
                            this.grupos = respuesta.data.data;
                        }

                    }
                )
            },
            agregar() {
                this.usuario = {
                    idUsuario: null,
                    sexo: null,
                    estadoCivil: null,
                    ocupacion: null,
                    medioContacto: null,
                    paterno: null,
                    materno: null,
                    nombre: null,
                    fechaNacimiento: null,
                    nombreUsuario: null,
                    password: null,
                    mesesVigencia: null,
                    registroActivo: null,
                    grupos: [],
                    clinicas: null,
                    cambioPassword: true,
                };
                this.tituloModal = 'Agregar Usuario';
                this.show = true;
            },
            guardar() {

              this.$v.usuario.$touch();
              if (this.$v.usuario.$anyError) {
                return;
              }
                // this.$v.usuario.$touch();
                // if (this.$v.usuario.$anyError) {
                //     return;
                // }
                // if (!this.$v.usuario.$invalid) {
                this.loaderAcciones = true;

                const envio = JSON.parse(JSON.stringify(this.usuario));
                envio.fechaNacimiento = this.$moment(envio.fechaNacimiento).utc()

                this.$http.post(this.$api + 'catalogo/usuario/guardar', envio).then(respuesta => {
                        if (respuesta.data.data) {
                            this.obtenerUsuarios();
                            this.show = false;
                            this.$swal.fire({
                                icon: "info",
                                title: "Aviso",
                                text: "El usuario se guardó correctamente",
                            });
                        }
                    }
                ).catch((error) => {
                  this.$swal.fire({
                    icon: "error",
                    title: "Aviso",
                    text: error.response.data.message,
                  });
                }).finally(() => {
                        this.loaderAcciones = false;
                    }
                )

                // }
            },
            modificar(item) {
                this.usuario = JSON.parse(JSON.stringify(item));
                this.tituloModal = 'Modificar usuario';
                this.mostrarBoton = true;
                this.show = true;
            },

            eliminar(item) {
                const mensaje = item.registroActivo ? '¿Está seguro de desactivar el usuario?' : '¿Está seguro de activar el usuario?';
                const mensajeAviso = item.registroActivo ? 'El usuario se desactivo correctamente' : 'El usuario se activo correctamente';
                this.$swal({
                    icon: "warning",
                    text: mensaje,
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((aceptar) => {
                    if (aceptar.value) {
                      const parametros = {
                        idUsuario: item.idUsuario,
                      }
                        this.$http.post(this.$api + 'catalogo/usuario/eliminar', parametros).then(respuesta => {
                                if (respuesta.data.data) {
                                    item.registroActivo = !item.registroActivo;
                                    this.$swal.fire({
                                        icon: "success",
                                        title: "Aviso",
                                        confirmButtonText: 'De acuerdo',
                                        text: mensajeAviso,
                                    });
                                }
                            }
                        )
                    }
                })
            },
            validateState(name) {
                const {$dirty, $error} = this.$v.usuario[name];
                return $dirty ? !$error : null;
            },
            cerrarModal() {
                this.show = false;
            },
            cambiarContrasenia() {
                this.respContrasenia = this.usuario.password;
                this.usuario.password = null;
                this.mostrarBoton = false;
            },
            cancelarCambio() {
                this.usuario.password = this.respContrasenia;
                this.respContrasenia = null;
                this.mostrarBoton = true;
            }
        }
    }
</script>

<style scoped>

</style>
